import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import EventSessionForm from "../EventSessionForm/EventSessionForm";
import { useEventSessionForm } from "../../hooks/useEventSessionForm";

interface CreateEventSessionDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  eventUuid: string;
}

function CreateEventSessionDrawer({
  isOpen,
  onClose,
  onSuccess,
  eventUuid,
}: CreateEventSessionDrawerProps) {
  const { handleClose: clearFormSessionDays } = useEventSessionForm({
    isEditMode: false,
    eventUuid,
  });

  const handleClose = () => {
    clearFormSessionDays();
    onClose();
  };

  return (
    <Transition.Root as={Fragment} show={isOpen}>
      <Dialog as="div" className="relative z-40" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-30" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col bg-white dark:bg-slate-900 shadow-xl">
                    <div className="flex items-center justify-between bg-primary px-4 py-4">
                      <Dialog.Title className="text-lg font-medium text-white">
                        Create Event Session
                      </Dialog.Title>
                      <button
                        className="text-white"
                        onClick={handleClose}
                        type="button"
                      >
                        <XMarkIcon className="h-6 w-6" />
                      </button>
                    </div>

                    <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6">
                      <EventSessionForm
                        eventUuid={eventUuid}
                        isEditMode={false}
                        onSuccessCallback={onSuccess}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default CreateEventSessionDrawer;
